import {request} from '@/utils/request'

import CacheUtil from '@/utils/cache'

export function getFriendLinksList(data, useCache = true, expire = 1800) {
    const cacheKey = `friend_${JSON.stringify(data || {})}`;

    // 如果启用缓存且缓存存在，直接返回缓存数据
    if (useCache) {
        const cachedData = CacheUtil.get(cacheKey);
        if (cachedData) {
            return Promise.resolve(cachedData);
        }
    }

    return request({
        url: '/system/getFriendLinksList',
        method: 'get'
    }).then(res => {
        // 如果启用缓存且请求成功，缓存数据
        if (useCache && res.data) {
            CacheUtil.set(cacheKey, res, expire);
        }
        return res;
    });
}

export function getSwiperList(data, useCache = true, expire = 1800) {
    const cacheKey = `swiper_${JSON.stringify(data || {})}`;

    // 如果启用缓存且缓存存在，直接返回缓存数据
    if (useCache) {
        const cachedData = CacheUtil.get(cacheKey);
        if (cachedData) {
            return Promise.resolve(cachedData);
        }
    }

    return request({
        url: '/system/getSwiperList/' + data,
        method: 'get'
    }).then(res => {
        // 如果启用缓存且请求成功，缓存数据
        if (useCache && res.data && res.data.code === 10000) {
            CacheUtil.set(cacheKey, res, expire);
        }
        return res;
    });
}

export function getAreaOptions(data, useCache = true, expire = 1800) {
    const cacheKey = `area_${JSON.stringify(data || {})}`;

    // 如果启用缓存且缓存存在，直接返回缓存数据
    if (useCache) {
        const cachedData = CacheUtil.get(cacheKey);
        if (cachedData) {
            return Promise.resolve(cachedData);
        }
    }

    return request({
        url: '/district/getAreaOptions',
        method: 'get'
    }).then(res => {
        // 如果启用缓存且请求成功，缓存数据
        if (useCache && res.data && res.data.code === 10000) {
            CacheUtil.set(cacheKey, res, expire);
        }
        return res;
    });
}


// 获取yoquiugn
export function youqing() {
    return request({
        url: '/system/getFriendLinksList',
        method: 'get'
    })
}


// 获取字典项
export function getDictValuesByKey(data) {
  return request({
    url: '/system/getDictValuesByKey',
    method: 'get',
    data
  })
}


// 获取默认地址
export function getDefault(data) {
    return request({
        url: '/people/peopleAddress/getDefault',
        method: 'get',
        data
    })
}

// 获取发票
export function getInvoice(data) {
    return request({
        url: '/people/peopleAddress/getInvoice',
        method: 'get',
        data
    })
}

// 获取配置信息
export function getConfigByKey(key) {
    return request({
        url: '/system/config/getConfigByKey/' + key,
        method: 'get',
    })
}

// 获取配置信息
export function getExpressList(data) {
    return request({
        url: '/order/getExpressList',
        method: 'get',
        data
    })
}

// 获取配置信息
export function getConfigByKeyPost(data) {
    return request({
        url: '/system/config/getConfigByKeys',
        method: 'post',
        data
    })
}

// 首页个人中心统计
export function getUserStatistics() {
    return request({
        url: '/people/user_statistics',
        method: 'get',
    })
}

// 搜索
export function search(data, config = {}) {
    return request({
        url: '/chemicals/search',
        method: 'get',
        data,
        cancelToken: config.cancelToken,
        timeout: config.timeout
    })
}

// 搜索详情
export function getDetail(id) {
    return request({
        url: '/chemicals/search/' + id,
        method: 'get'
    })
}
// 搜索详情
export function getCasOptions(data) {
    return request({
        url: '/chemicals/getCasOptions',
        method: 'get',
        data
    })
}

// 获取协议
export function getAgreeList(data) {
    return request({
        url: '/system/getAgreeList',
        method: 'post',
        data
    })
}

// 成为会员
export function member(data) {
    return request({
        url: '/people/member',
        method: 'post',
        data
    })
}

// 删除订单
export function deleteOrder(id) {
    return request({
        url: '/order/order/' + id,
        method: 'delete'
    })
}
// 获取手机号地址
export function getAreaCode() {
    return request({
        url: '/system/getAreaCode',
        method: 'get'
    })
}
export function getWebSiteService() {
    return request({
        url: '/website/getWebSiteService',
        method: 'get'
    })
}
export function getTechFilter(data, useCache = true, expire = 3600) {
    const cacheKey = `tech_${JSON.stringify(data || {})}`;

    // 如果启用缓存且缓存存在，直接返回缓存数据
    if (useCache) {
        const cachedData = CacheUtil.get(cacheKey);
        if (cachedData) {
            return Promise.resolve(cachedData);
        }
    }
 return request({
        url: '/tech/getTechFilter',
        method: 'get'
    }).then(res => {
        // 如果启用缓存且请求成功，缓存数据
        if (useCache && res.data) {
            CacheUtil.set(cacheKey, res, expire);
        }
        return res;
    });
}

